function tabs() {
	const tabButtons = document.querySelectorAll('.tab-button');
	const tabContent = document.querySelectorAll('.tab-content');
	if (tabContent.length > 0) {
		console.log(tabContent);
		tabContent[0].classList.add('is-active');

		tabButtons.forEach(function (e, i) {
			e.addEventListener('click', function () {
				tabContent.forEach(function (e) {
					e.classList.remove('is-active');
				});
				tabButtons.forEach(function (e) {
					e.classList.remove('is-active');
				});
				e.classList.add('is-active');
				tabContent[i].classList.add('is-active');
				window.scroll(0, tabContent[i].offsetTop);
			});
		});
	}
}

tabs();
